import React, { useState } from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { SidebarData } from './SidebarData';
import './Navbar.css';
import { IconContext } from 'react-icons';
import SearchIcon from '@material-ui/icons/Search';
import InputGroupDropdown from './InputGroupDropdown';

function Navbar() {
  const [sidebar, setSidebar] = useState(false);

  const showSidebar = () => setSidebar(!sidebar);
  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
        <div className="navbar">
          <div className="left">
            <Link to="#" className="menu-bars">
              <FaIcons.FaBars onClick={showSidebar} />
            </Link>
            <div className="navSearchBar">
              <select name="" id="">
                <option value="">All</option>
                <option value="">Art</option>
                <option value="">Photography</option>
                <option value="">Games</option>
                <option value="">Metaverses</option>
                <option value="">Music</option>
                <option value="">Domains</option>
                <option value="">DeFi</option>
              </select>
              <input type="text" className="searchInput" placeholder="Search items and collections" />
              <Link to="/search"><SearchIcon /></Link>
            </div>
          </div>
          <ul className="navBarRight">
            <InputGroupDropdown />
          </ul>
        </div>

        <nav className={sidebar ? 'nav-menu active' : 'nav-menu'}>
          <ul className="nav-menu-items" onClick={showSidebar}>
            <li className="navbar-toggle">
              <Link to="#" className="menu-bars">
                <AiIcons.AiOutlineClose />
              </Link>
            </li>
            {SidebarData.map((item, index) => {
              return (
                <li key={index} className={item.cName}>
                  <Link to={item.path}>
                    {item.icon}
                    <span>{item.title}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </IconContext.Provider>
    </>
  );
}

export default Navbar;
